import type { LocalizedStatus } from '@common/types'
import { StatusType } from '@common/types'
import { FinancialAccountStatus } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const financialAccountStatusMessages = defineMessages({
  active: {
    defaultMessage: 'Currently active',
    description: 'financial account status name',
  },
  proposed: {
    defaultMessage: 'Proposed',
    description: 'financial account status name',
  },
  terminated: {
    defaultMessage: 'Terminated',
    description: 'financial account status name',
  },
  unknown: {
    defaultMessage: 'Unknown',
    description: 'financial account status name',
  },
})

export function translateFinancialAccountStatus(
  intl: IntlShape,
  status: FinancialAccountStatus,
): string {
  switch (status) {
    case FinancialAccountStatus.ACTIVE:
      return intl.formatMessage(financialAccountStatusMessages.active)
    case FinancialAccountStatus.PROPOSED:
      return intl.formatMessage(financialAccountStatusMessages.proposed)
    case FinancialAccountStatus.TERMINATED:
      return intl.formatMessage(financialAccountStatusMessages.terminated)
    default:
      return intl.formatMessage(financialAccountStatusMessages.unknown)
  }
}

export function localizeFinancialAccountStatus(
  intl: IntlShape,
  status: FinancialAccountStatus,
): LocalizedStatus {
  switch (status) {
    case FinancialAccountStatus.PROPOSED:
      return {
        localized: intl.formatMessage(financialAccountStatusMessages.proposed),
        status: StatusType.INFO,
      }
    case FinancialAccountStatus.ACTIVE:
      return {
        localized: intl.formatMessage(financialAccountStatusMessages.active),
        status: StatusType.SUCCESS,
      }
    case FinancialAccountStatus.TERMINATED:
      return {
        localized: intl.formatMessage(financialAccountStatusMessages.terminated),
        status: StatusType.WARNING,
      }
  }
}
